"use client";

import {JSX, memo} from "react";

import Image from "next/image";

import {type FieldInstance} from "@/shared/models/form/fields";
import {type SelectInstance} from "@/shared/models/form/select";
import {TextField} from "@/shared/ui/form/fields/text-field";
import {SelectField} from "@/shared/ui/form/select/select-field";
import {assetPath} from "@/shared/utils/asset-path";

import "./styles/video-library-filters.scss";

// Valtio models - only used in client components, serialization check not applicable

type VideoLibraryFiltersProps = {
    location: SelectInstance<string>;
    category: SelectInstance<string>;
    subject: SelectInstance<string>;
    search: FieldInstance;
};

export const VideoLibraryFilters = memo(function VideoLibraryFilters({location, category, subject, search}: VideoLibraryFiltersProps): JSX.Element {
    return (
        <div className="video-library-filters">
            <SelectField model={location} label="Location" placeholder="All" />
            <SelectField model={category} label="Category" placeholder="All" />
            <SelectField model={subject} label="Subject" placeholder="All" />
            <TextField
                model={search}
                label=""
                placeholder="Search"
                className="video-library-filters__search"
                icon={<Image src={assetPath("/images/icons/search.svg")} alt="Search" width={16} height={16} />}
            />
        </div>
    );
});
